import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function TableLoader() {
  return <CircularProgress sx={{ position: "center" }} color={"success"} disableShrink />;
}